import { render } from "./ControlFiders.vue?vue&type=template&id=c523b00c&lang=true"
import script from "./ControlFiders.vue?vue&type=script&lang=js"
export * from "./ControlFiders.vue?vue&type=script&lang=js"

import "./ControlFiders.vue?vue&type=style&index=0&id=c523b00c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__